import { Component, Input, OnInit } from '@angular/core';

import { AbstractModal } from '../AbstractModal';
import { ModalService } from '../modal.service';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

@Component({
  selector: 'ls-giftcard-import',
  templateUrl: './import-modal.component.html',
  styleUrls: ['./import-modal.component.scss']
})
export class ImportModalComponent extends AbstractModal implements OnInit {
  @Input()
  data: {
    csvData: [string[], string[]];
    validate?: (file: File, content: string) => string[];
    helpArticle?: string;
  } = { csvData: [[], []] };

  errors: string[];
  csvTemplate: SafeUrl;

  constructor(private modal: ModalService, private sanitizer: DomSanitizer) {
    super();
  }

  ngOnInit() {
    this.csvTemplate = this.generateCSVTemplate();
  }

  public selectFile(event: Event) {
    const { files } = event.target as HTMLInputElement;
    const file: File = files && files.length && files[0];
    if (file) {
      readCSV(file).then(content => {
        const errors = this.data.validate
          ? this.data.validate(file, content)
          : [];
        if (errors.length > 0) {
          this.errors = errors;
        } else {
          const delimiter = getDelimiter(content, this.data.csvData[0]);
          this.modal.close([file, delimiter]);
        }
      });
    }
  }

  generateCSVTemplate() {
    if (this.data.csvData && this.data.csvData[0].length > 0) {
      const [header, row] = this.data.csvData;
      const csv = `${header.join(',')}\r\n${row.join(',')}`;
      return this.sanitizer.bypassSecurityTrustUrl(
        `data:text/csv;charset=utf-8,${encodeURIComponent(csv)}`
      );
    }
    return this.sanitizer.bypassSecurityTrustUrl('#');
  }

  public close(): void {
    this.modal.close();
  }
}

function readCSV(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsText(file);
    reader.onload = () => {
      if (reader && reader.result) {
        resolve(reader.result as string);
      } else {
        reject(new Error('Empty result'));
      }
    };
    reader.onerror = error => reject(error);
  });
}

function getDelimiter(content: string, headers: string[]): string {
  const delimiterRegex = new RegExp(
    `(('|")?(${headers.join('|')})('|")?)*`,
    'g'
  );
  const csvHeaders = content.split('\n')[0].replace('\r', '');
  const delimiter = csvHeaders.replace(delimiterRegex, '')[0];
  return delimiter;
}
